export const REQUEST_SEAT_UPGRADE_BANNER = 'requestSeatUpgradeBanner';
export const REQUEST_ADDITIONAL_SEATS = 'requestAdditionalSeats';
export const REQUEST_SEAT_BANNER = 'requestSeatBanner';
export const REQUEST_SKU = 'requestSKU';
export const REQUEST_TRIAL = 'requestTrial';
export const REQUEST_QUOTE = 'requestQuote';
export const REQUEST_PARTNER = 'requestPartnerScope';
export const REQUEST_MC_WRITE = 'requestMCWrite';
export const DEFAULT = 'default';